import httpClient from "@plugins/http";
import { EmbedAppModel, GetAppEmbedInfoParams } from "@plugins/richtext/types.ts";
import { ApiResponse } from "@apis/api.ts";

// TODO: [API] Confusing naming, this suppose to be configuration api OR richtext api to get html whitelist

const fetchWhiteList = () => {
  return httpClient.get("/apis/configuration/htmlWhitelist");
};

const getAppEmbedInfo = ({
  uuid,
  requestParams,
}: GetAppEmbedInfoParams): Promise<ApiResponse<EmbedAppModel>> => {
  return httpClient.get(`/apis/app/embed/info/${uuid}`, {
    params: requestParams,
  });
};

export default {
  fetchWhiteList,
  getAppEmbedInfo,
};
